import AddWidgetContainer from './AddWidget.container';
import AddWidget, { Props } from './AddWidget';
export default AddWidgetContainer(AddWidget);
export type Props = Props;
